import { FC } from 'react'
import { Box, IconButton, Paper, Tooltip, Typography, useTheme } from '@mui/material'
import { IoRefreshOutline } from 'react-icons/io5'
import { adminVersion } from '../../Services/api'
import { formatUserDisplayName } from './dashboard-cards.component'

interface IDashboardWelcomeProps {
  username?: string
  onRefresh?: () => void
  refreshing?: boolean
}

export const DashboardWelcome: FC<IDashboardWelcomeProps> = ({
  username,
  onRefresh,
  refreshing = false,
}) => {
  const theme = useTheme()

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, md: 2.5 },
        borderRadius: 3,
        mb: 2,
        bgcolor: 'primary.main',
        backgroundImage: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
        color: 'white',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {onRefresh && (
        <Box sx={{ position: 'absolute', top: 12, right: 12, zIndex: 3 }}>
          <Tooltip title="Atualizar indicadores">
            <span>
              <IconButton
                onClick={onRefresh}
                disabled={refreshing}
                size="small"
                sx={{
                  color: 'white',
                  bgcolor: 'rgba(255,255,255,0.12)',
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' },
                }}
                aria-label="Atualizar dashboard"
              >
                <IoRefreshOutline size={20} />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      )}

      <Box sx={{ position: 'relative', zIndex: 2, pr: { xs: 0, sm: 10 } }}>
        <Typography
          variant="overline"
          sx={{ opacity: 0.85, fontWeight: 700, letterSpacing: 1.5, lineHeight: 1.2 }}
        >
          Papello HUB
        </Typography>
        <Typography variant="h5" fontWeight={800} sx={{ mt: 0.25, letterSpacing: -0.3 }}>
          Olá, {formatUserDisplayName(username)}!
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.9, maxWidth: 480, mt: 0.75 }}>
          Acompanhe os indicadores do HUB e acesse os módulos do seu perfil.
        </Typography>
        <Typography variant="caption" sx={{ display: 'block', mt: 1, opacity: 0.7 }}>
          Versão {adminVersion}
        </Typography>
      </Box>

      <Box
        sx={{
          position: 'absolute',
          right: -28,
          top: -28,
          width: 140,
          height: 140,
          borderRadius: '50%',
          border: '24px solid rgba(255,255,255,0.08)',
          zIndex: 1,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          right: 36,
          bottom: -36,
          width: 100,
          height: 100,
          borderRadius: '50%',
          border: '18px solid rgba(255,255,255,0.05)',
          zIndex: 1,
        }}
      />
    </Paper>
  )
}
